function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20,22.9c-0.1,0-0.2,0-0.3,0c-3.2-0.4-6.4-1.5-9.1-3.2c-2.5-1.6-4.7-3.8-6.3-6.3c-1.8-2.7-2.9-5.9-3.2-9.1 c0-0.8,0.2-1.6,0.7-2.2s1.2-1,2-1.1C3.9,1,4,1,4.1,1h3l0,0c1.5,0,2.8,1.1,3,2.6c0.1,0.9,0.3,1.8,0.6,2.6c0.4,1.1,0.1,2.3-0.7,3.2 l-0.7,0.7c1.2,1.8,2.7,3.4,4.6,4.6l0.7-0.7c0.8-0.8,2.1-1.1,3.2-0.7c0.8,0.3,1.7,0.5,2.6,0.6c1.5,0.2,2.6,1.5,2.6,3v3 c0,0.8-0.3,1.6-0.9,2.1S20.8,22.9,20,22.9L20,22.9z M7.1,3L7.1,3h-3C3.8,3,3.5,3.2,3.3,3.4C3.2,3.6,3.1,3.8,3.1,4.1 C3.4,7,4.4,9.8,6,12.3c1.5,2.3,3.4,4.3,5.7,5.7c2.5,1.6,5.3,2.6,8.2,2.9c0.4,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.4,0.3-0.7v-3l0,0 c0-0.5-0.4-0.9-0.9-1c-1-0.1-2-0.4-3-0.8C16.7,15,16.3,15,16,15.3l-1.3,1.3c-0.3,0.3-0.8,0.4-1.2,0.2c-2.7-1.5-4.9-3.7-6.4-6.4 C7,10,7.1,9.5,7.4,9.2l1.3-1.3c0.2-0.2,0.3-0.7,0.2-1c-0.4-1-0.6-2-0.8-3C8.1,3.4,7.6,3,7.1,3z"
});

var SvgTel = function SvgTel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tel.d1dd6b52.svg";
export { ForwardRef as ReactComponent };